export default __webpack_public_path__ + "static/bricks-dedba5f7409233c46f3edb15badab946.svg";